import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cloud-migration-analysis-dashboard',
  templateUrl: './cloud-migration-analysis-dashboard.component.html',
  styleUrls: ['./cloud-migration-analysis-dashboard.component.scss']
})
export class CloudMigrationAnalysisDashboardComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
